import React from 'react';
import styled from 'styled-components';

import { Button } from './Buttons';

type Range = { from?: string; to?: string };

type Props = {
  className?: string;
  value?: Range;
  onChange?: (value: Range) => void;
  onRemove?: () => void;
  disabled?: boolean;
};

const Wrapper = styled.div`
  padding: 5px;
  ${Button} {
    margin-left: 10px;
  }
`;
const Input = styled.input``;
const Span = styled.span`
  margin: 0 8px;
`;

const TimeRange = ({ value, onChange, onRemove, className = '', disabled = false }: Props) => {
  return (
    <Wrapper className={className}>
      <Input
        disabled={disabled}
        type="time"
        onChange={(e) => {
          onChange?.({ ...value, from: e.target.value });
        }}
        value={value?.from}
      />
      <Span>~</Span>
      <Input
        disabled={disabled}
        type="time"
        onChange={(e) => {
          onChange?.({ ...value, to: e.target.value });
        }}
        value={value?.to}
      />
      <Button
        disabled={disabled}
        type="button"
        onClick={() => {
          //
          onRemove?.();
        }}
      >
        削除
      </Button>
    </Wrapper>
  );
};

export default styled(TimeRange)``;
